module.exports = __webpack_public_path__ + "static/img/new4-CfbMmQJw.2fe028b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new4-CfbMmQJw.png
// module id = JTla
// module chunks = 16